export default __webpack_public_path__ + "static/media/issuer-douyin.4d38a579.svg";